import { render, staticRenderFns } from "./UserInjuryChangeActivationType.vue?vue&type=template&id=3dfbcef4&"
import script from "./UserInjuryChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./UserInjuryChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports